// meeting page
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { createStore, bindActionCreators } from 'redux'
import { connect, Provider } from 'react-redux'
import MeetingDetailsReducer from './reducers/meeting.reducers'
import * as MeetingActions from './actions/meeting.actions'
import MeetingApp from './components/meetings/meetingApp'
import NewMeetingApp from './components/meetings/newMeetingApp'
import MeetingFeedbackApp from './components/meetings/meetingFeedbackApp'
import MeetingPrintViewComp from './components/print-meeting.comp'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

const mapsStateToPropsMeeting = state => ({
  meetingData: state
})

const mapsDispatchToPropsMeeting = dispatch => ({
  actions: bindActionCreators(MeetingActions, dispatch)
})

// This represents the /wb/meeting/meetingDetails?id= legacy page
//
export const MeetingAppProvider = function (data) {
  const meetingStore = createStore(
    MeetingDetailsReducer,
    data,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
  const MeetingAppContainer = connect(mapsStateToPropsMeeting, mapsDispatchToPropsMeeting)(MeetingApp)
  ReactDOM.render(
    <Provider store={meetingStore}>
      <Suspense fallback="loading...">
        <I18nextProvider i18n={i18n}>
          <MeetingAppContainer />
        </I18nextProvider>
      </Suspense>
    </Provider>,
    document.getElementById('msDetailsPage')
  )
}
window.initMeetingComp = MeetingAppProvider

// Legacy Meeting Topics and Takeaways section in the new Meeting Details page
//
export const NewMeetingAppProvider = React.memo(function ({ data, workstream, refreshLegacyData, setSnackbarState }) {
  data.workstream = workstream;
  const meetingStore = createStore(
    MeetingDetailsReducer,
    data,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
  const NewMeetingAppContainer = connect(mapsStateToPropsMeeting, mapsDispatchToPropsMeeting)(NewMeetingApp)
  return (
    <Provider store={meetingStore}>
      <Suspense fallback="loading...">
        <I18nextProvider i18n={i18n}>
          <NewMeetingAppContainer setSnackbarState={setSnackbarState} refreshLegacyData={refreshLegacyData} />
        </I18nextProvider>
      </Suspense>
    </Provider>
  )
})
window.NewMeetingAppProvider = NewMeetingAppProvider

// Legacy Feedback smilies and timer in new Meeting Details
//
export const MeetingFeedbackProvider = React.memo(function ({ data }) {
  const meetingStore = createStore(
    MeetingDetailsReducer,
    data,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
  const MeetingFeedbackContainer = connect(mapsStateToPropsMeeting, mapsDispatchToPropsMeeting)(MeetingFeedbackApp)
  return (
    <Provider store={meetingStore}>
      <Suspense fallback="loading...">
        <I18nextProvider i18n={i18n}>
          <MeetingFeedbackContainer />
        </I18nextProvider>
      </Suspense>
    </Provider>
  )
})
window.MeetingFeedbackProvider = MeetingFeedbackProvider

export const viewPrintSummaryMeeting = function (data) {
  $('#mainmenu').hide()
  $('#root').hide()
  $('#contentTd').remove()
  $('.left-sidebar').hide()
  $('#launcher').hide()
  $('.rbrLeftMenu').hide()
  $('.mywobo-page-wrapper').css({ marginLeft: '0px' })
  $('.wbContent').css('padding-top', '0px')
  ReactDOM.render(<MeetingPrintViewComp items={data} />, document.getElementById('msDetailsPage'))
}
window.viewPrintSummaryMeeting = viewPrintSummaryMeeting

